<script lang="ts" setup>
// -------------------------------
// 🔹 Props
// -------------------------------
/**
 * Props du composant
 * @property {number} sateIncrement - Valeur actuelle de l'incrément
 */
const props = defineProps(['sateIncrement']);

// -------------------------------
// 🔹 Événements émis
// -------------------------------
/**
 * Événements émis par le composant :
 * - "HandleDecreInscrement" : décrémente la valeur
 * - "HandleInscrement" : incrémente la valeur
 * - "HandleDelete" : supprime l'élément
 */
const emit = defineEmits([
  'HandleDecreInscrement',
  'HandleInscrement',
  'HandleDelete',
]);

// -------------------------------
// 🔹 Méthodes
// -------------------------------
/**
 * Décrémente la valeur de l'incrément et émet l'événement correspondant
 */
const HandleDecreInscrement = () => {
  emit('HandleDecreInscrement');
};

/**
 * Incrémente la valeur de l'incrément et émet l'événement correspondant
 */
const HandleInscrement = () => {
  emit('HandleInscrement');
};

/**
 * Supprime l'élément et émet l'événement correspondant
 */
const HandleDelete = () => {
  emit('HandleDelete');
};
</script>

<template>
  <div class="flex cursor-pointer flex-row items-center justify-center gap-2">
    <div
      class="decrementValue flex items-center justify-center"
      @click="HandleDelete"
      v-if="props.sateIncrement < 2"
    >
      <div class="flex items-center justify-center">
        <svg
          width="8"
          height="2"
          viewBox="0 0 14 2"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 1H13"
            stroke="#625353"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>

    <div
      v-else
      class="decrementValue flex items-center justify-center"
      @click="HandleDecreInscrement"
    >
      <div class="flex items-center justify-center">
        <svg
          width="8"
          height="2"
          viewBox="0 0 14 2"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 1H13"
            stroke="#625353"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
    <div class="textContainer flex h-auto content-end items-end justify-end">
      <p
        class="font-firs text-14px relative m-0 p-0 text-end font-medium tabular-nums"
      >
        {{ sateIncrement }}
      </p>
    </div>
    <div
      class="incrementValue flex items-center justify-center"
      @click="HandleInscrement"
    >
      <div class="flex items-center justify-center">
        <svg
          width="14"
          height="14"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 10H16"
            stroke="#625353"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10 16V4"
            stroke="#625353"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<style scoped>
.incrementValue {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 8px;
  gap: 16px;

  width: 30px;
  height: 30px;

  background: linear-gradient(95.96deg, #f7f7f7 -0.88%, #f7f7f7 100%);
  box-shadow:
    0px 0px 0px 1px rgba(147, 130, 130, 0.1),
    0px 3px 4px -1px rgba(147, 130, 130, 0.2),
    inset 0px 1px 0px #ffffff;
  border-radius: 10px;
}

.decrementValue {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 8px;
  gap: 16px;

  width: 30px;
  height: 30px;

  background: linear-gradient(95.96deg, #f7f7f7 -0.88%, #f7f7f7 100%);
  box-shadow:
    0px 0px 0px 1px rgba(147, 130, 130, 0.1),
    0px 3px 4px -1px rgba(147, 130, 130, 0.2),
    inset 0px 1px 0px #ffffff;
  border-radius: 10px;
}
</style>
